"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var DashboardProviderImpl = (function () {
    function DashboardProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " UserServiceImpl#")], args, false));
            }
        };
        this.log('created#');
    }
    DashboardProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    DashboardProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    DashboardProviderImpl.prototype.getAllUsers = function () {
        var collection = 'Users';
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, {}, { updated: -1 }, {}, '')
            .then(function (res) { return Promise.resolve(res.result ? res.result : []); });
    };
    DashboardProviderImpl.prototype.getUnitCourses = function (unit) {
        var collection = 'courses';
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, { unit: unit }, {}, {}, '')
            .then(function (res) { return Promise.resolve(res.result ? res.result : []); });
    };
    DashboardProviderImpl.prototype.getUnitExercises = function (unit) {
        var collection = 'exercises';
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, { unit: unit }, {}, {}, '')
            .then(function (res) { return Promise.resolve(res.result ? res.result : []); });
    };
    DashboardProviderImpl.prototype.getKernels = function (isDesktop) {
        var collection = 'kernels';
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, { kernelType: isDesktop ? 'desktop' : 'cloud' }, {}, {}, '')
            .then(function (res) { return Promise.resolve(res.result ? res.result : []); });
    };
    DashboardProviderImpl.prototype.getActiveUsers = function (beginTime, endTime) {
        var collection = 'history';
        var filter = {
            updated: {
                $gte: beginTime,
                $lte: endTime
            }
        };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, filter, {}, {}, 'uid')
            .then(function (res) { return Promise.resolve(res.result); });
    };
    DashboardProviderImpl.prototype.getCodeSubmits = function (data) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('CodeSubmit', data.filter, data.sort, data.projection, data.distinctKey)
            .then(function (res) { return Promise.resolve(res.result); });
    };
    DashboardProviderImpl.prototype.getCourseRegistrations = function (data) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('course_registration', data.filter, data.sort, data.projection, data.distinctKey)
            .then(function (res) { return Promise.resolve(res.result); });
    };
    DashboardProviderImpl.prototype.getEvents = function (data) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('events', data.filter, data.sort, data.projection, data.distinctKey)
            .then(function (res) { return Promise.resolve(res.result); });
    };
    DashboardProviderImpl.prototype.getUserActiveHistory = function (data) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('history', data.filter, data.sort, data.projection, data.distinctKey)
            .then(function (res) { return Promise.resolve(res.result); });
    };
    DashboardProviderImpl.prototype.stopAllMonitor = function () {
    };
    DashboardProviderImpl.prototype.countData = function (data) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .countData(data.collection, data.filter)
            .then(function (res) { return Promise.resolve(res.count); });
    };
    DashboardProviderImpl.prototype.getGeneralData = function (collection, filter, projection, sort, distinctKey, skip, limit) {
        skip = skip ? skip : 0;
        limit = limit ? limit : 0;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).query(collection, filter, sort, projection, distinctKey, skip, limit);
    };
    return DashboardProviderImpl;
}());
exports.DashboardProviderImpl = DashboardProviderImpl;
//# sourceMappingURL=DashboardProviderImpl.js.map